<template>
  <div>
    <Card>
      <Row>
        <Button type="info"
                @click="add">{{$t('pages_banners_index_178')}}</Button>
      </Row>
      <TablePaginate :columns="columns"
                     :data="seckills"
                     :loading="loading"
                     :meta="meta"
                     :changePage="changePage"></TablePaginate>
    </Card>
    <Modal v-model="modalShow"
           @on-ok="handleSubmit"
           :title="$t('pages_seckill_index_939')">
      <Form ref="category"
            :model="seckill"
            :label-width="80">
        <Form-item :label="$t('pages_bookings_new_232')"
                   prop="price">
          <select-product v-model="seckill.fresh_product_id" :modalType="formType" :name="seckill.fresh_product_name" @changeName="changeProduct"/>
        </Form-item>
        <Form-item :label="$t('pages_seckill_index_940')"
                   prop="price">
          <Input type="text" number
                 v-model="seckill.price" />
        </Form-item>
        <Form-item :label="$t('pages_product_stocks_index_740')"
                   prop="stores">
          <Input type="text" number
                 v-model="seckill.stores" />
        </Form-item>
        <Form-item :label="$t('pages_seckill_index_941')"
                   prop="limit_number">
          <Input type="text" number
                 v-model="seckill.limit_number" />
        </Form-item>
        <Form-item :label="$t('pages_enough_consume_discount_index_484')"
                   prop="start_at">
          <el-date-picker
            type="datetime"
            :placeholder="$t('pages_enough_consume_discount_index_484')"
            v-model="seckill.start_at"
            style="width: 200px;"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </Form-item>
        <Form-item :label="$t('pages_enough_consume_discount_index_485')"
                   prop="end_at">
          <el-date-picker
            type="datetime"
            :placeholder="$t('pages_enough_consume_discount_index_485')"
            v-model="seckill.end_at"
            style="width: 200px;"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </Form-item>
      </Form>
    </Modal>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import TablePaginate from '@/components/TablePaginate'
import { deleteButtonInTable, editorButtonInTable } from '@/libs/table-render'
import SelectProduct from '@/pages/seckill/components/SelectProduct'
export default {
  components: {
    TablePaginate,
    SelectProduct
  },
  data () {
    return {
      modalShow: false,
      formType: '',
      columns: [
        {
          title: i18n.t('pages_schedule_display_product_index_922'),
          key: 'fresh_product_id',
          width: 100
        },
        {
          title: i18n.t('pages_bookings_detail_222'),
          key: 'fresh_product_name',
          width: 150
        },
        {
          title: i18n.t('pages_seckill_index_940'),
          key: 'price',
          width: 100
        },
        {
          title: i18n.t('pages_seckill_index_941'),
          key: 'limit_number',
          width: 100
        },
        {
          title: i18n.t('pages_product_stocks_index_740'),
          key: 'stores',
          width: 100
        },
        {
          title: i18n.t('pages_seckill_index_942'),
          key: 'used_stores',
          width: 100
        },
        {
          title: i18n.t('pages_seckill_index_943'),
          key: 'residue_stores',
          width: 100
        },
        {
          title: i18n.t('pages_enough_consume_discount_index_484'),
          key: 'start_at',
          width: 200
        },
        {
          title: i18n.t('pages_enough_consume_discount_index_485'),
          key: 'end_at',
          width: 200
        },
        {
          title: i18n.t('pages_ai_image_163'),
          key: 'action',
          width: 200,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            const children = []
            children.push(deleteButtonInTable(this, h, params))
            children.push(editorButtonInTable(this, h, params))
            return h('div', children)
          }
        }
      ]
    }
  },
  created () {
    this.changeQuery({ page: 1 })
    this.index()
  },
  computed: {
    ...mapGetters('setting', ['setting']),
    ...mapState('seckill', ['seckill', 'seckills', 'meta', 'loading']),

  },
  methods: {
    ...mapActions('seckill', [
      'clear',
      'index',
      'show',
      'create',
      'update',
      'destroy'
    ]),

    ...mapMutations('seckill', ['changeQuery']),

    changeProduct (name) {
      console.log('name', name);
      this.seckill.fresh_product_name = name
    },
    changePage (page) {
      this.changeQuery({ page: page })
      this.index()
    },
    add () {
      this.clear()
      this.modalShow = true
      this.formType = 'new'
    },
    async handleSubmit () {
      if (this.formType === 'edit') {
        await this.update(this.seckill)
      } else if (this.formType === 'new') {
        await this.create(this.seckill)
      }
      this.modalShow = false
    },
  }
}
</script>
